<template>
  <div class="order-list">
    <div class="empty-logo">
      <div class="rhombus-narrow"></div>
      <div class="rhombus-narrow left">
        <div class="border"></div>
      </div>
      <div class="rhombus-narrow right">
        <div class="border"></div>
      </div>
    </div>
    <h4>你还没有任务</h4>
    <p>您可在此处查看任务信息、跟踪您的包裹,快去发布一个任务吧</p>
    <el-button class="block" type="info" @click="submit()">去发布</el-button>
  </div>
</template>

<script>
export default {
  name: 'OrderList',
  props: ['isSingle'],
  data () {
    return {
    }
  },
  methods: {
    submit () {
      if(this.isSingle) {
        this.$router.push('/buyer/publish_task/index')
      }else {
        this.$router.push('/customer/publish_task/cart')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.order-list {
  max-width: 320px;
  margin: 0 auto;
  text-align: center;

  h4 {
    font-size:16px;
    color: #333333;
    line-height:22px;
  }

  p {
    margin: 40px 25px 60px;
    color: #333333;
    font-size: 13px;
    line-height: 18px;
  }
}

.empty-logo {
  width: 90px;
  margin: 0 auto;
  height: 165px;

  $width: 45px;
  $height: 26px;
  .rhombus-narrow {
    width: 0;
    height: 0;
    border: $width solid transparent;
    border-bottom: $height solid #333333;
    position: relative;
    top: -$width;
  }
  .rhombus-narrow:after {
    content: '';
    position: absolute;
    left: -$width;
    top: $height;
    width: 0;
    height: 0;
    border: $width solid transparent;
    border-top: $height solid #333333;
  }

  .left,
  .right {
    .border {
      position: absolute;
      width: 86px;
      height: 2px;
    }
  }

  .left {
    border-bottom-color: #888;
    &:after {
      border-top-color: #888;
    }
    transform:rotate(60deg);
    top: -55px;
    left: 5px;
    .border {
      top: 25px;
      left: -43px;
      background-color: #888;
    }
  }

  .right {
    border-bottom-color: #666666;
    &:after {
      border-top-color: #666666;
    }
    transform:rotate(-60deg);
    top: -126px;
    left: -5px;
    .border {
      top: 25px;
      left: -43px;
      background-color: #666666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/Empty.vue